import * as React from 'react';
import { withStyles, WithStyles, createStyles, generateStaticClassName } from '@domonda/ui/styles';
import { Route, Link, RouteComponentProps } from 'react-router-dom';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

const breadcrumbsItemStyles = createStyles(({ palette, spacing }) => ({
  root: {
    color: palette.textSecondary,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: spacing(0.5),
    '& + &': {
      '&:before': {
        display: 'inline-block',
        content: '""',
        border: '3px solid',
        borderColor: 'transparent transparent transparent currentColor ',
      },
    },
    '&:first-of-type': {
      marginLeft: 0,
    },
  },
  link: {
    padding: spacing(0.25, 0.5),
    display: 'inline-block',
    textDecoration: 'none',
    color: 'currentColor',
    '&:hover, &:focus, &:active': {
      textDecoration: 'underline',
    },
  },
  label: {
    padding: spacing(0.25, 0.5),
    display: 'inline-block',
    color: 'currentColor',
  },
}));
const BreadcrumbsItem: React.FC<RouteComponentProps & WithStyles<typeof breadcrumbsItemStyles>> = ({
  match,
  classes,
  location,
}) => {
  // TODO-jht-190404 this is just a POC
  const isOverview = location.pathname.split('/').length <= 2;
  const translationPath = match.url.slice(1, match.url.length).toUpperCase();
  const { formatMessage } = useIntl();
  return (
    <>
      {isOverview ? (
        <>
          <li className={classes.root}>
            <span className={classes.label}>
              /{formatMessage({ id: `MENU_${translationPath}` })}
            </span>
          </li>
          <li className={classes.root}>
            <Link className={classes.link} to={match.url}>
              {formatMessage({ id: 'DOCUMENTS_OVERVIEW' })}
            </Link>
          </li>
        </>
      ) : (
        <li className={classes.root}>
          <Link className={classes.link} to={match.url}>
            {match.url}
          </Link>
        </li>
      )}
      {/* eslint-disable-next-line */}
      <Route path={`${match.url}/:path`} component={StyledBreadcrumbsItem} />
    </>
  );
};
const StyledBreadcrumbsItem = withStyles(breadcrumbsItemStyles)(BreadcrumbsItem);

const breadcrumbsStyles = createStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 12,
  },
  list: {
    marginLeft: -4,
    listStyle: 'none',
    margin: '6px 0',
    padding: 0,
    display: 'flex',
  },
});

interface Props {
  children?: React.ReactNode;
}

const breadcrumbClassName = generateStaticClassName('Breadcrumb');

const Breadcrumb: React.FC<Props & WithStyles<typeof breadcrumbsStyles>> = (props) => {
  const { classes } = props;

  return (
    <div className={clsx(breadcrumbClassName, classes.root)}>
      <ul className={classes.list}>
        <Route path="/:path" component={StyledBreadcrumbsItem} />
      </ul>
    </div>
  );
};

const Styled = withStyles(breadcrumbsStyles)(Breadcrumb);
export { Styled as Breadcrumb, breadcrumbClassName };
